//import Slider from "../slider";

export default {
  init: function () {},
  finalize: function () {
    // console.log("test");
    // $.getJSON("../wp-content/themes/sohoradio/week-info.json", function (json) {
    //   console.log("test");
    //   console.log(json);
    // });
  },
};
